<div class="SLV2-learn-complete-poparea">
    <button class="SLV2-popup-close-btn" (click)="close()">
        <img src="selflearnv2-ui/assets/img/self-learn-v2/close-black-icon.svg" />
    </button>

    <img src="selflearnv2-ui/assets/img/animation-champion-icon.gif" class="SLV2-champion-icon" />
    <h3 class="SLV2-complete-greeting-hdng">Yay! You’ve completed Learn!</h3>
    <p class="SLV2-complete-text">You’ve successfully completed with all the Learn content in this chapter,<br>continue with Practice to increase your understanding.</p>

    <div class="SLV2-complete-actn-area">
        <button class="SLV2-complete-solid-btn">Continue with Practice</button>
        <!-- <button class="SLV2-complete-text-btn">View solutions</button> -->
    </div>
</div>
